import React, { useState } from 'react';
import { Form, Button, InputGroup, Row, Col, Badge } from 'react-bootstrap';

const TableFilter = ({ 
  filters, 
  onFilterChange, 
  onClearFilters,
  filterConfig = []
}) => {
  const [localFilters, setLocalFilters] = useState(filters);

  const handleChange = (key, value) => {
    setLocalFilters(prev => ({ ...prev, [key]: value }));
  };

  const handleApply = () => {
    onFilterChange(localFilters);
  };

  const handleClear = () => {
    const clearedFilters = {};
    filterConfig.forEach(config => {
      clearedFilters[config.key] = '';
    });
    setLocalFilters(clearedFilters);
    onClearFilters();
  };

  const activeFiltersCount = Object.values(localFilters).filter(v => v).length;

  return (
    <div className="mb-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-0 fw-semibold">
          <i className="fas fa-filter me-2 text-primary"></i>
          Filters
          {activeFiltersCount > 0 && (
            <Badge bg="primary" className="ms-2">{activeFiltersCount}</Badge>
          )}
        </h6>
        <div className="d-flex gap-2">
          <Button 
            variant="outline-secondary" 
            size="sm"
            onClick={handleClear}
            disabled={activeFiltersCount === 0}
          >
            <i className="fas fa-times me-2"></i>Clear
          </Button>
          <Button 
            variant="primary" 
            size="sm"
            onClick={handleApply}
          >
            <i className="fas fa-check me-2"></i>Apply
          </Button>
        </div>
      </div>

      <Row className="g-3">
        {filterConfig.map((config) => (
          <Col md={config.colSize || 3} key={config.key}>
            <Form.Group>
              <Form.Label className="small fw-medium">{config.label}</Form.Label>
              {config.type === 'select' ? (
                <Form.Select
                  size="sm"
                  value={localFilters[config.key] || ''}
                  onChange={(e) => handleChange(config.key, e.target.value)}
                >
                  <option value="">All</option>
                  {config.options?.map(opt => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </Form.Select>
              ) : config.type === 'date' ? (
                <Form.Control
                  type="date"
                  size="sm"
                  value={localFilters[config.key] || ''}
                  onChange={(e) => handleChange(config.key, e.target.value)}
                />
              ) : (
                <InputGroup size="sm">
                  <InputGroup.Text>
                    <i className={config.icon || 'fas fa-search'}></i>
                  </InputGroup.Text>
                  <Form.Control
                    type={config.type || 'text'}
                    placeholder={config.placeholder || `Search ${config.label.toLowerCase()}...`}
                    value={localFilters[config.key] || ''}
                    onChange={(e) => handleChange(config.key, e.target.value)}
                  />
                </InputGroup>
              )}
            </Form.Group>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default TableFilter;
